import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../modules/auth';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(
    public toasterService: ToastrService,
    private authService: AuthService
  ) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // if (req.method !== 'GET') {
    //     this.toasterService.success('Success', null, {timeOut: 2000});
    // }

    const token = this.authService.getToken();

    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.getToken()}`,
        },
      });
    }

    return next.handle(req).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse) {
        }
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          console.log(err);
          try {
            this.toasterService.error(
              typeof err.error === 'string'
                ? err.error.replace(/\n/g, '</br>')
                : err.error.title.replace(/\n/g, '</br>'),
              'Error',
              { timeOut: 4000, enableHtml: true }
            );
            if (err.status === 401) {
              this.authService.logout();
            }
          } catch (e) {
            this.toasterService.error('An error occurred', '');
          }
        }
        return of(err);
      })
    );
  }
}
